<template>
  <p
    dir="ltr"
    class="clearfix mb-0 font-weight-semi-bold"
  >
    <span class="float-md-right d-none d-md-block">Copyright {{ new Date().getFullYear() }} - Made with passion by WiSHOP
      <feather-icon
        icon="HeartIcon"
        size="18"
        class="stroke-current"
      />
    </span>
  </p>
</template>

<script>

export default {
}
</script>
